import { apiFetch } from "./apiFetch";

export async function listThread(peerId) {
  const data = await apiFetch(`/api/messages/thread/${peerId}`, { method: "GET" });
  return Array.isArray(data?.items) ? data.items : [];
}

export async function sendMessage({ toId, text }) {
  return apiFetch(`/api/messages`, {
    method: "POST",
    body: JSON.stringify({ toId, text }),
  });
}

export async function getUnreadCount() {
  const data = await apiFetch(`/api/messages/unread-count`, { method: "GET" });
  return Number(data?.count || 0);
}

export async function markRead(peerId) {
  return apiFetch(`/api/messages/mark-read/${peerId}`, { method: "POST" });
}

export async function listInbox() {
  const data = await apiFetch(`/api/messages/inbox`, { method: "GET" });
  return Array.isArray(data?.items) ? data.items : [];
}
